(function () {
  'use strict';

  angular.module('app.dashboard.main', []);

})();
